// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.tooltip-line-value {
  margin-left: 5px;
  filter: brightness(0.8);
  font-size: 13px;
}
.tooltip-icon {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 10px;
}
.tooltip-line {
  padding: 1px;
  white-space: pre;
}
.tooltip-header {
  white-space: pre;
  margin: 5px 10px;
  font-size: 14px;
  text-align: center;
}
.tooltip-line-title {
  color: #636363;
  font-size: 14px;
  margin-left: 5px;
  width: 120px;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-flex;
}
.tooltip-time-since {
  font-size: 12px; text-align: center;
}
.tooltip {
  font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  position: absolute;
  width: 240px;
  transform: translate(-50%, -100%) translate(0px, -15px);
  z-index: 999;
  background: white;
  border-radius: 6px;
  color: #4d4d4d; 
  box-shadow: 0 3px 14px rgb(0 0 0 / 40%);
}
.tooltip-content {
  margin: 13px 19px;
  line-height: 1.4;
}
.tooltip-tip-container {
  width: 40px;
  height: 20px;
  position: absolute;
  left: 50%;
  margin-left: -20px;
  overflow: hidden;
  pointer-events: none;
}
.tooltip-tip {
  background: white;
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  transform: rotate(45deg);
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/ag-plot/ag-plot.ts"],"names":[],"mappings":";;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,eAAe,EAAE,kBAAkB;AACrC;AACA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,uDAAuD;EACvD,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;AAC1B","sourcesContent":["\n\n.tooltip-line-value {\n  margin-left: 5px;\n  filter: brightness(0.8);\n  font-size: 13px;\n}\n.tooltip-icon {\n  width: 10px;\n  height: 10px;\n  display: inline-block;\n  border-radius: 10px;\n}\n.tooltip-line {\n  padding: 1px;\n  white-space: pre;\n}\n.tooltip-header {\n  white-space: pre;\n  margin: 5px 10px;\n  font-size: 14px;\n  text-align: center;\n}\n.tooltip-line-title {\n  color: #636363;\n  font-size: 14px;\n  margin-left: 5px;\n  width: 120px;\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-flex;\n}\n.tooltip-time-since {\n  font-size: 12px; text-align: center;\n}\n.tooltip {\n  font: 12px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n  position: absolute;\n  width: 240px;\n  transform: translate(-50%, -100%) translate(0px, -15px);\n  z-index: 999;\n  background: white;\n  border-radius: 6px;\n  color: #4d4d4d; \n  box-shadow: 0 3px 14px rgb(0 0 0 / 40%);\n}\n.tooltip-content {\n  margin: 13px 19px;\n  line-height: 1.4;\n}\n.tooltip-tip-container {\n  width: 40px;\n  height: 20px;\n  position: absolute;\n  left: 50%;\n  margin-left: -20px;\n  overflow: hidden;\n  pointer-events: none;\n}\n.tooltip-tip {\n  background: white;\n  width: 17px;\n  height: 17px;\n  padding: 1px;\n  margin: -10px auto 0;\n  transform: rotate(45deg);\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
